import { PlusOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { useBookingV4Actions } from '../context';
import { IBookingV4StaffItem } from '../types';
import StaffBlock from './StaffBlock';
import { AddStaffButton, Container, TitleRow } from './styles';

type ContentProps = {
  value?: IBookingV4StaffItem[];
};

const StaffServiceContent = ({ value = [] }: ContentProps) => {
  const actions = useBookingV4Actions();
  return (
    <Container>
      <TitleRow>
        <span className="title">Staff &amp; Services</span>
        <AddStaffButton type="button" onClick={actions.addNewStaff}>
          <PlusOutlined />
          <span>Add Staff</span>
        </AddStaffButton>
      </TitleRow>

      {value.map((block) => (
        <StaffBlock
          key={block.id}
          staff={block}
          onChangeStaff={() => actions.changeStaff(block.id)}
          onPickTime={() => actions.pickStaffTime(block.id)}
          onToggleRequest={() => actions.toggleRequest(block.id)}
          onRemoveStaff={() => actions.removeStaff(block.id)}
          onAddService={() => actions.addNewService(block.id)}
          onRemoveService={(serviceId) => actions.removeService(block.id, serviceId)}
          onEditService={(service) => actions.editStartTime(block.id, service)}
        />
      ))}
    </Container>
  );
};

const BookingV4StaffServiceSection = () => {
  return (
    <Form.Item noStyle name="staffs">
      <StaffServiceContent />
    </Form.Item>
  );
};

export default BookingV4StaffServiceSection;
